import readMore from "../components/readmore";

const Team = () =>{
    console.log('Team');
    readMore()
}

export default Team